<template>
  <div class="h-screen flex w-full bg-img vx-row items-center justify-center" id="page-login">
      <div class="vx-col">
          <vx-card>
              <div slot="no-body" class="full-page-bg-color">
                  <div class="vx-col d-theme-dark-bg">
                      <div class="p-8 login-tabs-container">

                          <div class="vx-card__title mb-4">
                              <center class="mb-4">
                                  <img src="logo.png" alt="logo" width="81px" height="81px">
                              </center>
                              <p>Cliquer sur <strong>Connexion</strong> pour ouvrir une session !</p><br><br>
                          </div>

                          <div>
                              <vs-button class="w-full" @click="adLogin()">Connexion</vs-button>
                              <br>
                          </div>

                      </div>
                  </div>
              </div>
          </vx-card>
      </div>
  </div>
</template>

<script>
  import auth from "../../helper/auth";
  export default{
      data() {
          return {
              form:{
                  email: "",
                  password: "",
              },
              errors: [],
              eye: false
          }
      },
      methods:{
          adLogin(){
            //const callback = 'http://165.22.28.198:8097/callback';
            const callback = 'https://cnhu-consult.gouv.bj/callback';
            const url = `https://pprodofficial.service-public.bj/official/login?client_id=cnhu-ussd&redirect_uri=${callback}&response_type=code&scope=openid&authError=true`
            //const url = 'https://official.pprod.service-public.bj/official/login?client_id=cnhu-ussd&redirect_uri=http://165.22.28.198:8097/callback&scope=openid&response_type=code&authError=true';
            const link = document.createElement('a');
            link.href = link.href = url;
            //link.setAttribute('target', '_blank');
            document.body.appendChild(link);
            link.click();
          },

          login(){
              this.$vs.loading()
              this.$http.post('auth/login', this.form).then((response) =>{
                  if (response.data.status){
                      auth.authenticate(response.data)
                      this.errors = []
                      if (response.data.user.profile == '1'){
                        this.$router.push({name: 'payments'})
                      }else this.$router.push('/')
                      this.$vs.loading.close()
                  }
              }).catch((error) => {
                  this.$vs.loading.close()
                  this.errors = error.response.data.errors
              })
          }
      }
  }
</script>

<style lang="scss">
  #page-login {
      .social-login-buttons {
          .bg-facebook { background-color: #1551b1 }
          .bg-twitter { background-color: #00aaff }
          .bg-google { background-color: #4285F4 }
          .bg-github { background-color: #333 }
      }
  }
  .i-toggle{
    display: flex;
    flex-direction: row;
  }
  .toggle-icon{
    margin-left: -23px;
    padding-top: 9px;
  }
</style>
